export default __webpack_public_path__ + "static/media/fitness-tracker.0cbc6c25.gif";